export default "__VITE_ASSET__2i1Sfk0O__"